<template>
<div >
<div class="container " style="padding-left:10px"><h3> <a href="javascript:;" @click="viewProfile()" >Back to {{initReservation.SitterName}} Profile</a></h3> </div>
               <div class="modal-dialog" style="margin-top:0px;">
                  <div class="modal-content ">
                    <div class="modal-header">
                      <h3 style="margin-top:0px; margin-bottom:0px;" class="text-center"><i class="fa fa-calendar"></i> Booking Request</h3>
                    </div>
                    <div class="modal-body" style="overflow:hidden;">
                      <div class="well" style="overflow: hidden; padding:3px;">
                                   <div class="col-sm-12 remove-margins">
            <div class="col-sm-12 remove-margins">
            <div class="col-sm-12  col-xs-12">
                <h3 class="text-success"><strong>Step 1 - Choose Service Type</strong></h3>
            <div class="row">
                
                <div class="col-xs-12 col-sm-6">
                    
                    <label   class="h3" style="margin-bottom:5px; margin-top:10px;">
                    <input type="radio"  v-model="serviceType" value="1" @click="setServiceBoarding()"> <span>&nbsp<i class="fa fa-shopping-basket"/>  Boarding at Sitters Home</span>
                    </label>
                    </div>
                    <div  class="col-xs-12 col-sm-6 ">
                    <label class="h3" style="margin-bottom:5px; margin-top:10px;">
                    <input type="radio" v-model="serviceType" value="2" @click="setServiceSitting()"><span>&nbsp <i class="fa fa-home"/> Sitting at Owners Home</span>
                </label>
                </div>
                 <div v-if="dogWalking==true" class="col-xs-12 col-sm-6 ">
                    <label class="h3" style="margin-bottom:5px; margin-top:10px;">
                    <input type="radio" v-model="serviceType" value="6" @click="setServiceDogWalking()"><span>&nbsp <i class="fa fa-paw"/> Dog Walking </span>
                </label>
                </div>
      
            </div>
            <br>
            
             
            <alert :message="notification.DateMessage" :type="'alert-warning'"></alert>
            <alert :message="notification.PetMessage" :type="'alert-warning'"></alert>
            <h3 class="text-success" style="margin-bottom:20px;"><strong>Step 2 - Select the Booking dates</strong></h3>
             <!--Start of form flex-->
              <div class="form-from-date">
                <div v-if="serviceType==6">
               
                    <h5>When do you prefer to start</h5>
                    </div>
                <div class="form-group">
                    <div class='input-group date' id='ReservationFrom'>
                    <!--<input v-model="datesData.start" class="form-control input-text" placeholder="Pick up" readonly="true"/>-->
                    <label type='text' readonly="true" v-model="datesData.start" class="form-control input-text" >{{startDateMobileComp}}</label>
                    <span class="input-group-addon">
                                <span class="fa fa-calendar"></span>
                    </span>
                    </div>
                </div>
                </div>
                <div v-show="serviceType!=6" class="form-to-date">
                <div class="form-group">
                    <div class='input-group date' id='ReservationTo'>
                    <!--<input v-model="datesData.end" class="form-control input-text" placeholder="Drop off" readonly="true" :disabled="!datesData.start"/>-->
                    <label type='text' readonly="true" v-model="datesData.end" :disabled="!datesData.start" class="form-control input-text" >{{endDateMobileComp}}</label>
                    <span class="input-group-addon">
                                <span class="fa fa-calendar"></span>
                    </span>
                    </div>
                </div>
                
                </div>

                <div v-if="serviceType==6" class="form-location">
                    <hr>
                    <h5>How many walks per week</h5>
                    
                        <div class="form-group">
                            <div class='form-group '>
                                <select required name="citySelect" class="form-control " v-model="initReservation.WalksPerWeek">
                                  <option v-for="walk in walksPerWeek" v-bind:value="walk.time">
                                    {{walk.name}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                    </div>
                    <hr>
            
            </div> <!--End of form flex-->
             
            </div>
            
            <div class="col-sm-6 col-xs-12">
                <h3 class="text-success"><strong>Step 3 - Select Pets to stay</strong></h3>
               <button class="btn btn-default special-button margin-items" :class="{active: petCard.IsSelected}" @click="selectPet(petCard)" v-for="petCard in initReservation.AvailablePetDtos">
                     <PetSelectCard v-bind:petId="petCard.PetId" :key="petCard.PetId"></PetSelectCard>
                     
               </button>
            </div>
           
             
            <div class="col-sm-12 col-xs-12" style="margin-top:20px">
                    <div v-if="serviceType!=0" v-for="service in initReservation.AvailableSitterServiceDtos" class="margin-items">
                            <button :class="{active: service.IsSelected}" v-show="serviceType==1" v-if="service.ServiceType==5" @click="selectService(service)" class="btn btn-block btn-default">
                             <h4 > 
                             <i class="fa fa-bus"/> {{service.Description}} </h4>
                            <span   class="small">{{service.Price}} <span class="p smaller">{{service.DescriptionPer}}</span></span>
                            
                            </button>
                           
                    </div>
                    
                    </div>
                    
                </div> 
                <div class="col-xs-12">

                <br>
                <h3 class="text-success"><strong>Step 4 - Optional Message to Sitter</strong></h3>
                <h5>Message to Sitter</h5>
                <textarea style="font-size: 16px;" v-model="initReservation.Message" :placeholder="messageToSitterComp" class="form-control" rows="5"></textarea>
                </div>
                <div class="col-sm-12 col-md-offset-2 col-md-8 col-xs-12">
                
                <br>
                <button class="btn btn-success btn-lg btn-block"  @click="submitRequest()"><i v-if="sending==true" class="fa fa-circle-o-notch fa-spin"></i> {{buttonText}}</button>        
                <br>
                </div>
                </div>
            </div>        
                      </div >  <!--end of modal well-->
                    </div> <!--end of modal body-->
                  </div> <!--end of modal content-->
                </div>
    
      </div>
</template>
<script>


import auth from '../../../auth'
import store from '../../../data/store'
import PetSelectCard from '../../SharedComponents/PetSelectCard'
import PetDetailsView from '../../SharedComponents/PetDetailsView'

export default {
    data () {
        return {
            initReservation: '',
            notification:'',
            error: false,
            sending: false,
            sittingDogs: false,
            walksPerWeek: [
                {name: '1 time only', time: 1},
                {name: '2 times', time: 2},
                {name: '3 times', time: 3},
                {name: '4 times', time: 4},
                {name: '5 times', time: 5},
                {name: '6 times', time: 6},
                {name: '7 times', time: 7},
            ],
            sittingCats: false,
            boardingDogs: false,
            boardingCats: false,
            dogWalking: false,
            serviceType: 0, //1=Boarding, 2=Sitting
            sent: false
        }
    },
    components: {
        PetSelectCard,
        PetDetailsView
    },
    computed: {
         messageToSitterComp: function(){
             if (this.serviceType!=6){
                 return 'Provide the sitter with details about your pets, their routine, behavior etc, they might ask more if needed.'
             } else {
                 return 'Provide the sitter on your home/location details, what time they would need to pick up your dog, and any additional info that might be useful.'
             }
             
        },
        startDateMobileComp: function(){
            if (this.datesData.start==null && this.serviceType!=6){
                return 'Pickup Date'
            } else if (this.datesData.start==null && this.serviceType==6){
                return 'Choose your first date'
            }
                else
            {
                return this.datesData.start
            }
        },
        endDateMobileComp: function(){
            if (this.datesData.end==null){
                return 'Dropoff Date'
            } else
            {
                return this.datesData.end
            }
        },
        
        currencyComp: function(){
            return store.getters.CountryData.Currency
        },
        datesData: function(){
            return store.getters.QueryData
        },
        buttonText: function(){
            if (this.sent == true)
            {
                return "Sent Successfully"
            }
            if (this.sending==false && this.error==false){
                return "Send Request"
            } else if (this.sending==true){
                return "Sending"
            } else if (this.sending==false && this.error==true){
                return "Sending Failed"
            }
        },
        selectedPetsComp: function(){
            var self = this
            var selectedPets = false
            if (self.initReservation.AvailablePetDtos!=null){
                $.each(self.initReservation.AvailablePetDtos, function(index, pet){
                    if (pet.IsSelected==true)
                        selectedPets = true
                })
                
                return selectedPets
                    
                
            }
        }
    },
    watch: {
        'datesData.end': function(){
            if (this.datesData.end!=null)
            {
                this.checkData()
            }
        },
        'datesData.start': function(){
            if (this.datesData.end!=null)
            {
                this.checkData()
            }
        },
        'datesData.dogWalkStart': function(){
            if (this.datesData.dogWalkStart!=null)
            {
                this.checkData()
            }
        }

    },
    created: function(){
        var self = this
             
        $.ajax("https://www.dupaws.com/services/api/customer/initReservation/" + self.$route.params.sitterId, {
                type: 'GET',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                  self.initReservation = data
                  self.initReservation.StartDate = self.datesData.start
                  self.initReservation.EndDate = self.datesData.end
                  $.each(self.initReservation.AvailableSitterServiceDtos, function(index, service){
                      if (service.ServiceType==1)
                        self.boardingDogs = true
                      if (service.ServiceType==2)
                        self.boardingCats = true
                      if (service.ServiceType==3)
                        self.sittingDogs = true
                      if (service.ServiceType==4)
                        self.sittingCats = true
                      if (service.ServiceType==6)
                        self.dogWalking = true
                  })
                },
                error: function () {
                    
                }
        });
        
    },
    methods: {
        setServiceBoarding: function(){
            var self =this
            // $.each(self.initReservation.AvailableSitterServiceDtos, function(index, service){
            //         service.IsSelected = false
            //          if (service.ServiceType==1)
            //             service.IsSelected=true
            //     })
            
            $.each(self.initReservation.AvailablePetDtos, function(index, pet){
                pet.IsSelected = false
            })

            self.serviceType=1
              
        },
        setServiceSitting: function(){
            var self =this
            // $.each(self.initReservation.AvailableSitterServiceDtos, function(index, service){
            //         service.IsSelected = false
            //          if (service.ServiceType==2)
            //             service.IsSelected=true
            //     })
            
            $.each(self.initReservation.AvailablePetDtos, function(index, pet){
                pet.IsSelected = false
            })

            self.serviceType=2
              
        },
        setServiceDogWalking: function(){
            var self =this
            $.each(self.initReservation.AvailableSitterServiceDtos, function(index, service){
                    service.IsSelected = false
                    if (service.ServiceType==6)
                        service.IsSelected=true
                })
            
            $.each(self.initReservation.AvailablePetDtos, function(index, pet){
                pet.IsSelected = false
            })
            
            self.datesData.end = self.datesData.start
            self.serviceType=6
              
        },
        selectPet: function(petCard){
            var self = this
            if (self.serviceType==0)
                {
                 swal("Service Type", "Please select service type first", "info")
                 return
                }

            if (petCard.PetType==1)
            {
            if (self.serviceType==6 && self.dogWalking == false){
                  swal("Dog Walking not offered", "Please make sure the sitter provide dog walking in their services", "info")
                   return
            }

            if (self.serviceType==1 && self.boardingDogs==false)
                {
                  swal("Dog Boarding not offered", "Please make sure the sitter provide dog boarding before adding a dog", "info")
                   return
                }
            if (self.serviceType==2 && self.sittingDogs==false)
                {
                  swal("Dog Sitting not offered", "Please make sure the sitter provide Dog Sitting before adding a dog", "info")
                   return
                }
            
            }   
            else if (petCard.PetType==2)
            {
            if (self.serviceType==1 && self.boardingCats==false)
                {
                  swal("Cat Boarding not offered", "Please make sure the sitter provide cat boarding before adding a cat", "info")
                   return
                }
            
            if (self.serviceType==2 && self.sittingCats==false)
                {
                  swal("Cat Sitting not offered", "Please make sure the sitter provide Cat Sitting before adding a cat", "info")
                   return
                }
            
            if (self.serviceType==6)
                {
                 {
                  swal("You have choosen Dog Walking service", "Please make sure to select a dog pet and not a cat :)", "info")
                   return
                }   
                }
            }


            if (petCard.IsSelected==false){
                petCard.IsSelected=true
                $.each(self.initReservation.AvailableSitterServiceDtos, function(index, service){
                    if (petCard.PetType==1){
                        if (service.ServiceType == 1 && self.serviceType==1) //dog boarding
                            service.IsSelected = true
                        else if (service.ServiceType == 3 && self.serviceType==2) //dog sitting
                            service.IsSelected = true
                    } else if (petCard.PetType==2){
                        if (service.ServiceType == 2 && self.serviceType==1) //cat boarding
                            service.IsSelected = true
                        else if (service.ServiceType == 4 && self.serviceType==2) //cat sitting
                            service.IsSelected = true
                    }
            
                });
                self.checkData()
              } 
                else
              {
                var dogSitting = false
                var catSitting = false
                petCard.IsSelected=false
                
                $.each(self.initReservation.AvailablePetDtos, function(index, pet){
                    if (pet.IsSelected == true)
                    {
                        if (pet.PetType==1)
                            dogSitting=true
                        if (pet.PetType==2)
                            catSitting=true
                        
                    }
                        
                });
                

                if (petCard.PetType==1 && dogSitting==false && self.serviceType==1){
                    var self = this
                    const index = self.initReservation.AvailableSitterServiceDtos.findIndex(t => t.ServiceType === 1)
                    if (index != null) {
                        self.initReservation.AvailableSitterServiceDtos[index].IsSelected = false
                    }
                }
                if (petCard.PetType==1 && dogSitting==false && self.serviceType==2){
                    var self = this
                    const index = self.initReservation.AvailableSitterServiceDtos.findIndex(t => t.ServiceType === 3)
                    if (index != null) {
                        self.initReservation.AvailableSitterServiceDtos[index].IsSelected = false
                    }
                } 
                if (petCard.PetType==2 && catSitting ==false && self.serviceType==1){
                    var self = this
                    const index = self.initReservation.AvailableSitterServiceDtos.findIndex(t => t.ServiceType === 2)
                    if (index != null) {
                        self.initReservation.AvailableSitterServiceDtos[index].IsSelected = false
                    }
                }
                if (petCard.PetType==2 && catSitting == false && self.serviceType==2){
                    var self = this
                    const index = self.initReservation.AvailableSitterServiceDtos.findIndex(t => t.ServiceType === 4)
                    if (index != null) {
                        self.initReservation.AvailableSitterServiceDtos[index].IsSelected = false
                    }
                
                }
                
                self.checkData()
            }
        },
        submitRequest: function(){
            var self = this;
            var phoneSuspect = /\d(([\. \- \_\!\@\`\~\+\<\>\,  ]){0,5}?\d){6,12}/;
            if (phoneSuspect.test(this.initReservation.Message))
            {
                swal("Sharing Mobile Phones", "Please do not include your phone number in the Message to Sitter, phone numbers can be exchanged later when the pet sitter accepts your request","info")
                return;
            }
            if (self.datesData.start==null && self.serviceType==6){
                swal("Oops.", "Dog Walking Start date required, please fill in the start of your preferred date", "error");
            }
            if ((self.datesData.start==null || self.datesData.end==null) && self.serviceType!=6){
                swal("Oops.", "Pickup or Dropoff date is empty, please fill both dates accordingly", "error");
            }
            else if (self.notification.DateMessage){
                swal("Oops.", self.notification.DateMessage, "error");
            } else if (!self.selectedPetsComp){
                swal("Oops.", "Please select at least one Pet before sending", "error");
            }
            else {
                self.sent=false
                self.sending=true
                $.ajax("https://www.dupaws.com/services/api/customer/submitReservation/", {
                        type: 'POST',
                        beforeSend: function(xhr){
                            xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                        },
                        data: JSON.stringify(self.initReservation),
                        contentType: "application/json; charset=utf-8",
                        crossDomain: true,
                        success: function (data) {
                            console.log(data)
                            self.sent=true
                            self.sending=false
                            self.error=false
                            
                            self.$router.push({path:'/view-reservation/' + data})
                      
                            
                        },
                        error: function (data, status, error) {
                            self.sending=false
                            self.error=true,
                            swal("Oops.", data.responseJSON.Message, "error");
                        }
                });
            }
        },
        viewProfile: function(){
            var self = this
            this.$router.push({path:'/sitter/' + self.$route.params.sitterId})
        },
        goHome: function(){
            this.$router.push({path: '/'})
        },
        selectService: function(service){
            var self = this
            if (service.IsSelected==false){
                service.IsSelected=true
                self.checkData()
            } else
            {
                service.IsSelected=false
                self.checkData()
            }
        },
        checkData: function(){
            var self = this
            self.initReservation.StartDate = self.datesData.start
            self.initReservation.EndDate = self.datesData.end
            

            $.ajax("https://www.dupaws.com/services/api/customer/verifyReservation/", {
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                data: JSON.stringify(self.initReservation),
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                    self.notification = data
                },
                error: function (data, status, error) {
                    
                }
        });
        }
    },
    mounted: function () {
        var self = this
        this.$ga.page(this.$router)
        self.$nextTick(function() {
            $('#ReservationTo').datepicker({
                        autoclose: true,
                        format: 'yyyy-mm-dd',
                        todayHighlight: true,
                        beforeShowDay: function(date) {
                            if (!self.datesData.start){
                                return date.valueOf() >= new Date();
                                } else {
                                return date.valueOf() >= moment(self.datesData.start)
                            }
                        
                        },
            }).on('changeDate', function (selected){   //When changing date..
                    self.datesData.end =  moment(selected.date).format('YYYY-MM-DD')                
            });


            $('#ReservationFrom').datepicker({
                    autoclose: true,
                    format: 'yyyy-mm-dd',
                    todayHighlight: true,
                    beforeShowDay: function(date) {
                        return moment(date).add(1,"days") >= moment();
                        
            },
            }).on('changeDate', function (selected){  //When changing date..
                                
                                self.datesData.start =  moment(selected.date).format('YYYY-MM-DD')
                                if (!self.datesData.end){   //Fill end date to start date if it's empty only                        
                                $('#ReservationTo').datepicker('update', self.datesData.start)
                                self.datesData.end = self.datesData.start

                                } else if (self.datesData.end<self.datesData.start){
                                
                                $('#ReservationTo').datepicker('update', self.datesData.start)
                                self.datesData.end = self.datesData.start
                                
                                } else {  //This step is needed if customer goes back in date on findSittersDatePickerFrom to allow for beforeShowDay refresh.
                                $('#ReservationTo').datepicker('destroy')
                                $('#ReservationTo').datepicker({
                                                autoclose: true,
                                                format: 'yyyy-mm-dd',
                                                todayHighlight: true,
                                                beforeShowDay: function(date) {
                                                        return date.valueOf() >= moment(self.datesData.start)
                                                        }
                                                }).on('changeDate', function (selected){   //When changing date..
                                                self.datesData.end =  moment(selected.date).format('YYYY-MM-DD')                
                                    });
                                }
            });
        });  // end of nextTick!
        

    
    }

}
 
</script>
<style scoped>

.smaller{
    font-size: small !important;
}

.special-button{
    
    color: none !important;
    text-align:left;
    font-size: smaller !important;
}

.btn-default {
    color: #6c6b6b !important;
    
}

.some-style{
    background-color: white;
    padding: 1px;
    border-radius: 2px;
    border: 5px #09589e;
    box-shadow: 0 0 0 2px #e0e0e0;
    
    margin-bottom:3%;
}

.margin-items{
    margin:5px;
}

.btn-default:hover {
    color: #333;
    background-color: #ffffff;
    border-color: #a7a7a7;
}

.btn-default:focus, .btn-default.focus {
    color: #333;
    background-color: white;
    border-color: #8c8c8c;
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}

</style>


// WEBPACK FOOTER //
// InitReservation.vue?4871389e